import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAssessment } from '../../contexts/AssessmentContext';
import { PackConfidence } from '../../types/assessment';
const QUESTIONS: {
  key: 'q1' | 'q2' | 'q3';
  label: string;
}[] = [{
  key: 'q1',
  label: 'What did you check against source documents? Name the documents and the specific assertions you tested.'
}, {
  key: 'q2',
  label: 'What did you accept from the assistant, or from the pack, without checking — and why?'
}, {
  key: 'q3',
  label: 'What would you verify next if you had 30 more minutes? Rank by risk, not by ease.'
}];
const CONFIDENCE: {
  id: PackConfidence;
  label: string;
}[] = [{
  id: 'yes',
  label: 'Yes'
}, {
  id: 'with-flags',
  label: 'With the flags noted'
}, {
  id: 'no',
  label: 'No, material issues remain'
}];
export function ReflectionPanel() {
  const {
    reflection,
    setReflection,
    packConfidence,
    setPackConfidence,
    submit,
    flags,
    locked
  } = useAssessment();
  const navigate = useNavigate();
  const entries = Object.values(flags);
  const flagged = entries.filter(f => f.kind === 'flag').length;
  const corrected = entries.filter(f => f.kind === 'correction').length;
  const complete = QUESTIONS.every(q => reflection[q.key].trim().length > 0) && packConfidence !== null;
  const onSubmit = () => {
    if (!complete || locked) return;
    submit();
    navigate('/submitted');
  };
  return <section className="border-t border-slate-200 bg-white" aria-label="Reflection and submission" data-id="element-307" data-mp="3rfavkdmasyen">
      <div className="mx-auto max-w-[1600px] px-6 py-8" data-id="element-308" data-mp="3mgq1yx1jxcz6">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_320px]" data-id="element-309" data-mp="571f56ud450w">
          <div data-id="element-310" data-mp="54yja66j3ho9">
            <h2 className="text-base font-semibold text-slate-900" data-id="element-311" data-mp="8hud9ri8za4">Reflection</h2>
            <p className="mt-1 text-sm text-slate-500" data-id="element-312" data-mp="aktcjamy2qz">
              All three answers are required. Write as much or as little as you need.
            </p>

            <div className="mt-5 space-y-5" data-id="element-313" data-mp="1bmloqh208pfp">
              {QUESTIONS.map((q, i) => <div key={q.key} data-id="element-314" data-mp="1ipjtvct4pycc" data-mpi={i}>
                  <label htmlFor={q.key} className="block text-sm font-medium text-slate-800" data-id="element-315" data-mp="1iso4arx6tqbg">
                    {i + 1}. {q.label}
                  </label>
                  <textarea id={q.key} rows={4} disabled={locked} value={reflection[q.key]} onChange={e => setReflection({
                ...reflection,
                [q.key]: e.target.value
              })} className="mt-2 w-full rounded-lg border border-slate-300 p-3 text-sm leading-relaxed text-slate-900 focus:border-slate-500 focus:outline-none focus:ring-2 focus:ring-slate-200 disabled:bg-slate-50" data-id="element-316" data-mp="1spstl0mby1wh" />
                </div>)}
            </div>

            <fieldset className="mt-8 rounded-lg border border-slate-200 bg-slate-50 p-5" data-id="element-317" data-mp="h9lz2ggyr28g">
              <legend className="px-1 text-sm font-medium text-slate-900" data-id="element-318" data-mp="h7rnvtvhuohk">
                Ready to submit this close pack to the Group Controller?
              </legend>
              <div className="mt-3 flex flex-wrap gap-2" data-id="element-319" data-mp="2zif9e3lsdn88">
                {CONFIDENCE.map(c => <button key={c.id} type="button" disabled={locked} onClick={() => setPackConfidence(c.id)} className={`rounded-lg border px-4 py-2.5 text-[13px] font-medium transition-colors disabled:opacity-50 ${packConfidence === c.id ? 'border-slate-900 bg-slate-900 text-white' : 'border-slate-300 bg-white text-slate-700 hover:border-slate-400'}`} data-id="element-320" data-mp="2vi512kaiukq7">
                    {c.label}
                  </button>)}
              </div>
            </fieldset>
          </div>

          <aside className="lg:pt-1" data-id="element-321" data-mp="1xstl9t2c4wdo">
            <div className="rounded-lg border border-slate-200 p-5" data-id="element-322" data-mp="1sus4jesdt95d">
              <h3 className="text-sm font-semibold text-slate-900" data-id="element-323" data-mp="1swlbywatjxef">Your entries</h3>
              <p className="mt-2 font-mono-num text-sm text-slate-700" data-id="element-324" data-mp="3sx9p2nnyw4wc">
                {flagged} flagged · {corrected} corrections applied
              </p>
              <p className="mt-2 text-xs leading-relaxed text-slate-500" data-id="element-325" data-mp="3j7hw1xvinjtz">
                Entries stay editable from the ledger and P&amp;L tabs until you submit.
              </p>

              <button type="button" onClick={onSubmit} disabled={!complete || locked} className="mt-5 w-full rounded-md bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-slate-700 disabled:cursor-not-allowed disabled:bg-slate-300" data-id="element-326" data-mp="3a6joj5lvcu6n">
                Submit close pack
              </button>
              {!complete && <p className="mt-2 text-xs text-slate-500" data-id="element-327" data-mp="yhsirpago63e">
                  Answer all three questions and choose a sign-off to enable submission.
                </p>}
            </div>
          </aside>
        </div>
      </div>
    </section>;
}